import ProcessingSoldHeader from "./Header";
import "./index.css";
import { useState, useEffect } from "react";
import ProcessingNoDataContents from "./ProcessingNoData";
import WasteGeneratedContents from "./WasteGenerated";
import ProcessingDataContents from "./ProcessingData";
import { ShowHide } from "../components/ShowHideProduct";
import FlowNumbersBox from "../components/FlowNumbersBox";
import { getProductDetail } from "../../../../apis/Product";
import { useLocation } from "react-router-dom";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProcessingIntermediateComponent = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const business = queryParams.get("business");
  const [functionalUnit, setFunctionalUnit] = useState("");
  useEffect(() => {
    getProductDetail({
      id: productId,
      business: business,
      setFunctionalUnit: setFunctionalUnit,
    });
  }, [productId, business]);

  return (
    <div className="processing-sold-container" id="processing-id">
      <ProcessingSoldHeader productId={productId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />

        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 15"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && <ProcessingNoDataContents productId={productId} />}
      {show && (
        <ProcessingDataContents
          productId={productId}
          functionalUnit={functionalUnit}
        />
      )}
      {show && <WasteGeneratedContents productId={productId} />}
    </div>
  );
};

export default ProcessingIntermediateComponent;
